import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import xIcon from 'core/assets/svg/x.svg';

import { Label } from 'core/components/label';

import useStyles from './modal.styles';

const Modal = ({ open, onClose, title, children, primaryActionText, onPrimaryAction, loading }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        root: classes.dialogRoot,
        container: classes.backdrop,
        paper: classes.dialogPaper,
        scrollPaper: classes.scrollPaper
      }}
    >
      {/* close button */}
      <Grid container justifyContent="flex-end">
        <IconButton className={classes.dialogCloseButton} onClick={onClose}>
          <img src={xIcon} alt="Close" className={classes.dialogCloseButtonIcon} />
        </IconButton>
      </Grid>

      {/* title & rest of content */}
      <DialogTitle>
        <Label type="title" className={classes.dialogTitle}>
          {title}
        </Label>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>{children}</DialogContent>

      {/* actions */}
      {!loading && (
        <DialogActions className={classes.dialogActions}>
          <Button variant="contained" onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button variant="contained" onClick={onPrimaryAction} color="primary">
            {primaryActionText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  primaryActionText: PropTypes.string,
  onPrimaryAction: PropTypes.func,
  loading: PropTypes.bool
};

export default Modal;
